import endpoints, { axios } from "../config/api";

function getUser(userId: string) {
  return axios.get(endpoints.users.get(userId));
}

export default getUser;
